import React from 'react';

export const FlagIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/flag' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='akar-icons:flag' transform='translate(3.000000, 3.000000)'>
          <rect id='ViewBox' x='0' y='0' width='24' height='24'></rect>
          <g
            id='Group'
            transform='translate(4.000000, 3.000000)'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
          >
            <path
              d='M0,12 L13.865,12 C14.2529065,11.9998546 14.6057342,11.7753895 14.7702432,11.4240944 C14.9347521,11.0727992 14.8812602,10.6580576 14.633,10.36 L11,6 L14.633,1.64 C14.8812602,1.34194237 14.9347521,0.927200794 14.7702432,0.57590563 C14.6057342,0.224610467 14.2529065,0 13.865,0 L0,0 L0,18'
              id='Path'
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
